// extracted by mini-css-extract-plugin
export default {"container":"styles_container__ku7jB","btn":"styles_btn__croxS","btn_sign":"styles_btn_sign__vTTEL","qrLoader":"styles_qrLoader__D37aa"};